import { createContext, useContext } from "react";

import type { Connector } from "./connection";
import type { LocalStoreFactory } from "./useCollaboration";

/**
 * How a screen opens a collaborative session.
 *
 * Production supplies none of this: the defaults open a real websocket and mirror
 * the replica into IndexedDB. It exists so a test can hand the document screen a
 * fake transport without stubbing our own modules (ADR-105) — a websocket is not
 * something the `fetch` mock can stand in for, and driving Hocuspocus against a
 * jsdom socket would test the library rather than the screen.
 */
export interface CollaborationConfig {
  /** Opens the session. Defaults to the Hocuspocus connector. */
  connector?: Connector;
  /** The offline mirror. `null` disables it, which is what jsdom needs. */
  localStore?: LocalStoreFactory | null;
  /** `false` forces every document screen onto the non-realtime editor. */
  enabled?: boolean;
}

const empty: CollaborationConfig = {};

export const CollaborationConfigContext = createContext<CollaborationConfig>(empty);

export function useCollaborationConfig(): CollaborationConfig {
  return useContext(CollaborationConfigContext);
}
